import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { login, register, logout, getProfile, clearError } from '../store/slices/authSlice';

export const useAuth = () => {
  const dispatch = useDispatch();
  const { user, isAuthenticated, isLoading, error, accessToken } = useSelector((state) => state.auth);

  useEffect(() => {
    if (accessToken && !user) {
      dispatch(getProfile());
    }
  }, [accessToken, user, dispatch]);

  const handleLogin = useCallback(
    (credentials) => dispatch(login(credentials)),
    [dispatch]
  );

  const handleRegister = useCallback(
    (userData) => dispatch(register(userData)),
    [dispatch]
  );

  const handleLogout = useCallback(
    () => dispatch(logout()),
    [dispatch]
  );

  const handleClearError = useCallback(
    () => dispatch(clearError()),
    [dispatch]
  );

  return {
    user,
    isAuthenticated,
    isLoading,
    error,
    login: handleLogin,
    register: handleRegister,
    logout: handleLogout,
    clearError: handleClearError,
    isAdmin: user?.role === 'admin',
    isManager: user?.role === 'manager',
  };
};
